import { useQuery } from '@tanstack/react-query';

import Client from '@/common/utils/client.utility';

export interface responseItem {
  isActive: boolean;
  id: number;
  faceToFaceSales: boolean;
  address: string;
  title: string;
  mobiles: string[];
  tels: string[];
  faxs: string[];
  emails: string[];
  location: { lat: number; lng: number } | null;
}

export interface serviceResponse {
  data: responseItem[];
}

export const getContactUs = async (): Promise<serviceResponse> => {
  const client = new Client();
  return await client.get<serviceResponse>(
    '/v1/personalpage/Shopper/ContactUs'
  );
};

export const useGetContactUs = () =>
  useQuery({
    queryFn: getContactUs,
    queryKey: ['contact_us'],
    staleTime: 5 * 60 * 1000,
  });
